import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { CreditBlockView } from './creditBlockView';
import { creditMessages } from './creditMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the credit block; each part uses its own slice of it */
import styles from './StudioCreditBlock.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CreditCostCellProps {
  cost: number;
  view: CreditBlockView;
}

/**
 * "This costs" of the credit block (design release-kit t5): the credits of this make, "Free" for
 * an image, or "Pro plan" for a full video or the motion artwork on a plan without them.
 */
const CreditCostCellComponent: React.FC<CreditCostCellProps> = ({ cost, view }) => {
  const intl = useIntl();

  return (
    <div className={styles.cell}>
      <span className={styles.key}>{intl.formatMessage(creditMessages.blockCostTitle)}</span>
      {view.costKind === 'plan' && (
        <>
          <span className={clsx(styles.value, styles.valueLock)} data-testid="credit-block-cost">
            {intl.formatMessage(creditMessages.blockProPlan)}
          </span>
          <span className={styles.sub}>{intl.formatMessage(creditMessages.blockProPlanSub)}</span>
        </>
      )}
      {view.costKind === 'free' && (
        <>
          <span className={clsx(styles.value, styles.valueGood)} data-testid="credit-block-cost">
            {intl.formatMessage(creditMessages.blockFree)}
          </span>
          <span className={styles.sub}>{intl.formatMessage(creditMessages.blockFreeSub)}</span>
        </>
      )}
      {view.costKind === 'credits' && (
        <span className={styles.value}>
          <span data-testid="credit-block-cost">{intl.formatNumber(cost)}</span>
          <small className={styles.unit}>{intl.formatMessage(creditMessages.blockCostUnit, { count: cost })}</small>
        </span>
      )}
    </div>
  );
};

export const CreditCostCell = TypedMemo(CreditCostCellComponent);
